// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import proposalReviewEntity from './entities/proposal-review.json';
import proposalReviewMenu from '../pages/proposal-review/menu.json';
import proposalReviewFullForm from '../pages/proposal-review/forms/full.json';
import proposalReviewContextForm from '../pages/proposal-review/forms/context.json';
import proposalReviewMiniForm from '../pages/proposal-review/forms/mini.json';
import proposalReviewLookupForm from '../pages/proposal-review/forms/lookup.json';
import proposalReviewTableView from '../pages/proposal-review/views/table.json';
import proposalReviewCardsView from '../pages/proposal-review/views/cards.json';
import proposalReviewDashboardView from '../pages/proposal-review/views/dashboard.json';

/** Тип запису «Розгляд пропозиції» зі сторінками пакета: меню, форми та подання з pages/proposal-review/. */
export const proposalReviewDefinition: IRecordTypeDefinition = {
  ...proposalReviewEntity,
  views: assembleViewSet({
      table: proposalReviewTableView,
      cards: proposalReviewCardsView,
      dashboard: proposalReviewDashboardView,
  }),
  form: proposalReviewFullForm,
  forms: { full: proposalReviewFullForm, context: proposalReviewContextForm, mini: proposalReviewMiniForm, lookup: proposalReviewLookupForm },
  menu: proposalReviewMenu,
} as IRecordTypeDefinition;
